export default __webpack_public_path__ + "static/media/newSet1-3-min.9b747d8d.png";